import React, {useEffect, useState} from 'react';
import AssessmentSidebar from "../components/Sidebar/AssessmentSidebar";
import "../assets/css/assessment.css";
import routes from "../routes";
import {Link, Redirect, Route, Switch} from "react-router-dom";
import {
    Button,
    Col,
    Collapse,
    Container,
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    Media,
    Modal,
    ModalBody,
    ModalHeader,
    Nav,
    Navbar,
    NavItem,
    Progress,
    Row,
    UncontrolledDropdown
} from "reactstrap";
import aceLogo from "../assets/img/brand/ace-logo.png";
import progressLogo from "../assets/img/brand/logo-progress.png";
import activ8Logo from "../assets/img/icons/user/activ8Logo.png";
import drop from "../assets/img/icons/header/dropdown.png";
import {getAuth, signOut} from "firebase/auth";
import PlanCard from "../components/Custom/PlanCard";

import {collection, getDocs, orderBy, query} from "firebase/firestore";
import {getDb} from 'util/Constants';


const Assessment = (props) => {
    const [isOpen, setIsOpen] = useState(false);
    const [userData, setUserData] = useState({});
    const [progressStatus, setProgressStatus] = useState(10);
    const [planModal, setPlanModal] = useState(false);
    const auth = getAuth();
    const isProgress = props.signedInUser.projectType === "progress";

    const [pricingPlans, setPricingPlans] = useState([])


    const styles = {
        navStyle: {
            // backgroundColor: '#fba51b',
            color: 'white',
            padding: "2px",
            borderRadius: '50px'
        },
        textColor: {
            color: 'white'
        },
        lineHeight: {
            lineHeight: '5px',
            fontSize: "15px"
        },
        fontSize: {
            fontSize: '3rem'
        }
    }

    // useEffect(() => {
    //     console.log(userData);
    //     console.log(routes.assessment.some(route => route.root), "Assessment Routes");
    //     console.log(routes[props.signedInUser.role], "Props user Routes");
    //
    // }, [userData]);

    useEffect(() => {
        fetchPricingPlansData()
    }, [])

    const fetchPricingPlansData = async () => {
        try {
            const dataArr = []
            const q = query(collection(getDb(), "pricing_plans"), orderBy("orderPosition"));
            const querySnapshot = await getDocs(q);
            querySnapshot.forEach((doc) => {
                dataArr.push({ ...doc.data() })
            });
            console.log("dasdaasd", dataArr)

            // Filter out free plan element
            const filteredPricingPlans = dataArr.filter((pricingPlan) => pricingPlan.name !== "Free");

            setPricingPlans(filteredPricingPlans)

        } catch (error) {

        }
    }



    useEffect(() => {
        console.log(userData);
        let progress = 4; // Initial progress value

        // Step - 1
        if (userData.eventData?.assessmentName && userData.eventData?.assessmentFor) {
            progress += 12;
        }

        if (isProgress) {
            // Step - 2
            if (userData.eventData?.selectedLevels?.competencies?.length === 4) {
                progress += 12;
            }
            // Step - 3
            if (userData.eventData?.selectedLevels?.games?.length >= 2) {
                progress += 24;
            }
        } else {
            // Step - 2
            if (userData.eventData?.selectedLevels?.competencies?.length === 4) {
                progress += 12;
            }

            // Step - 3
            if (userData.eventData?.selectedLevels?.cognitive?.length === 2) {
                progress += 12;
            }

            // Step - 4
            if (userData.eventData?.selectedLevels?.aptitude?.length === 2) {
                progress += 12;
            }
        }


        // Step - 5
        if (userData.eventData?.registrationFields?.length >= 1) {
            progress += 12;
        }

        // Step - 6
        if (userData.eventData?.loginMethod?.length >= 1) {
            progress += 12;
        }

        // Step - 7
        if (userData.eventData?.companyLogo) {
            progress += 12;
        }

        // Step - 8
        if (userData.eventData?.launchDate && userData.eventData?.closingDate) {
            progress += 12;
        }

        if (progress === 100) {
            setProgressStatus(100);
        } else {
            setProgressStatus(progress);
        }
    }, [userData]);

    const toggle = () => setIsOpen(!isOpen);

    const togglePlanModal = () => {
        setPlanModal(!planModal);
    }
    const getRoutes = (routes) => {
        return routes.map((route, key) => {
            return (
                <Route
                    exact
                    key={key}
                    path={route.layout + route.path}
                    name={route.name}
                    render={renderProps => route.root === true ?
                        renderWithoutSidebar(renderProps, route) : renderWithSidebar(renderProps, route)
                    }
                />
            );
        });
    };
    const renderHeader = () => {
        return (
            <Navbar color="dark" dark expand="md" className="new-bg">
                <Container className="assessment-main-container">
                    <Link style={{pointerEvents: window.location.pathname==="/assessment/loading" ? 'none' : ''}} to="/assessment/dashboard" disabled={window.location.pathname==="/assessment/index"} onClick={() => {
                        console.log(window.location.pathname);
                        setUserData({})
                    }}>
                        <div className="pr-5"><img
                            src={props.metadata.environment === "progress" ? progressLogo : aceLogo} alt="" /></div>
                    </Link>
                    {/*<NavbarToggler onClick={toggle}/>*/}
                    <Collapse isOpen={isOpen} navbar className="justify-content-between">
                        <Nav className="me-auto" navbar>
                            <NavItem>
                                <Link style={{pointerEvents: window.location.pathname==="/assessment/loading" ? 'none' : '' ,color: window.location.pathname==="/assessment/loading"?"lightgrey":"white"}}  to="/assessment/dashboard" onClick={() => {
                                    setUserData({})
                                }}>My Dashboard</Link>
                            </NavItem>
                        </Nav>
                        {routes.assessment.map((_item, index) => {
                            if (!_item.root && props.location.pathname === _item.layout + _item.path) {
                                return (
                                    <div key={index}>
                                        <span className="fs-14 text-white ml-3 font-weight-600">{progressStatus}% to complete</span>
                                        <div className="assessment-loading-wrapper d-none d-lg-block d-md-block">
                                            <Progress
                                                // striped
                                                bar
                                                className="py-1 rounded-pill"
                                                value={progressStatus}
                                            >
                                            </Progress>
                                        </div>
                                    </div>
                                )
                            }
                        })}
                        <Nav style={styles.navStyle}
                            className="align-items-center d-none d-md-flex justify-content-between">
                            <UncontrolledDropdown nav>
                                <DropdownToggle style={{display: window.location.pathname==="/assessment/loading" ? 'none' : ''}} className="pr-0 b" nav>
                                    <Media className="align-items-center ">
                                        <Media className="ml-2 d-none d-lg-block mx-2">
                                            <span style={styles.lineHeight} className="mb-0  text-white custom-font">
                                                {
                                                    props.signedInUser.name ? props.signedInUser.name :
                                                        (props.signedInUser.email && props.signedInUser.email.split('@')[0])
                                                }
                                                <img className="ml-3" src={drop} />
                                            </span>
                                        </Media>
                                        {/* className="avatar avatar-sm mx-1" */}
                                        <span className="mx-2">
                                            {/*<img*/}
                                            {/*    alt="..."*/}
                                            {/*    src={loginImg}*/}
                                            {/*/>*/}
                                        </span>

                                    </Media>
                                </DropdownToggle>
                                <DropdownMenu className="dropdown-menu-arrow" right>
                                    <DropdownItem className="noti-title" header tag="div">
                                        <h6 className="text-overflow m-0">Welcome!</h6>
                                    </DropdownItem>
                                    <DropdownItem href="#pablo" onClick={(e) => {
                                        e.preventDefault();
                                        signOut(auth).then(() => {
                                            // Sign-out successful.
                                        }).catch((error) => {
                                            // An error happened.
                                        });
                                    }}>
                                        <i className="ni ni-user-run" />
                                        <span>Logout</span>
                                    </DropdownItem>
                                </DropdownMenu>
                            </UncontrolledDropdown>
                        </Nav>
                    </Collapse>
                    {props.location.pathname !== '/assessment/index' &&
                        <div className="d-lg-none d-md-none d-block">
                            <span
                                className="fs-14 text-white ml-3 font-weight-600">{progressStatus}%  to complete</span>
                            <div className="assessment-loading-wrapper">
                                <Progress
                                    bar
                                    className="py-1 rounded-pill"
                                    value={progressStatus}
                                >
                                </Progress>
                            </div>
                        </div>
                    }
                </Container>
            </Navbar>
        );
    };
    const renderFooter = () => {
        return (
            <div className="assessment-footer py-3">
                <Container fluid
                    className="d-flex align-items-center justify-content-between flex-wrap assessment-main-container">
                    <img src={activ8Logo} />
                    <span className="text-sm footer-text">
                        © {new Date().getFullYear()}{" "}
                        <a
                            className="ml-1 text-dark"
                            href="https://activ8games.com" target="_blank"
                        >
                            All rights reserved Activ8Games
                        </a>
                    </span>
                </Container>
            </div>
        );
    };
    const renderWithSidebar = (renderProps, route) => {
        return (
            <Row>
                <Col lg={3} md={3}>
                    <AssessmentSidebar {...props} userData={userData}
                        routes={routes.assessment.filter(item => {
                            if (props.signedInUser.projectType === "progress" && item.name === "Behavioral Assessment") {
                                item.name = "Behavioral Competency"
                            }
                            if (props.signedInUser.projectType === "progress" && item.name === "Assessment Information") {
                                item.name = "Game Information"
                            }
                            if (!item.root && item.type === "generic" || item.type === props.signedInUser.projectType)
                                return item
                        })}
                        logo={{
                            innerLink: "/assessment",
                            imgSrc: require("../assets/img/brand/ace-logo.png").default,
                            imgAlt: "...",
                        }} />
                </Col>
                <Col lg={9} md={9}>
                    <div className="">
                        <route.component {...renderProps} signedInUser={props.signedInUser}
                            userData={userData} setUserData={setUserData} eventData={props.eventData} />
                        <Container className="justify-content-end d-flex align-items-center mt-3 flex-wrap">
                            {/*<img src={activ8Logo}/>*/}
                            {props.signedInUser?.plan === "free" && !isProgress&&
                                <div className="plan-container">
                                    <span>Your current plan is: FREE</span>
                                    <Button color="" className="plan-button" onClick={togglePlanModal}> Upgrade your
                                        plan</Button>
                                </div>
                            }
                        </Container>
                    </div>
                </Col>
            </Row>
        )
    }
    const renderWithoutSidebar = (renderProps, route) => {
        return (
            <>
                <route.component {...renderProps} signedInUser={props.signedInUser} togglePlanModal={togglePlanModal}
                    metadata={props.metadata}
                    userData={userData} setUserData={setUserData} eventData={props.eventData} />
                {!props.location.pathname.includes("dashboard") &&
                    <Container className="justify-content-end d-flex align-items-center footer flex-wrap">
                        {/*<img src={activ8Logo}/>*/}
                        {props.signedInUser?.plan === "free" && !isProgress &&
                            <div className="plan-container">
                                <span>Your current plan is: FREE</span>
                                <Button color="" className="plan-button" onClick={togglePlanModal}> Upgrade your
                                    plan</Button>
                            </div>
                        }
                    </Container>
                }
            </>
        )
    }

    console.log("pricingPlans", pricingPlans)

    return (
        <>
            {/*<Container className="assessment-main-container">*/}
            <div className="d-flex flex-column justify-content-between" style={{ height: "100vh" }}>
                <div>
                    {renderHeader()}
                </div>
                <Switch>
                    <Container className="assessment-main-container mb-5">
                        {getRoutes(routes.assessment)}
                    </Container>
                    <Redirect from="*" to="/assessment/dashboard" />
                </Switch>
                {renderFooter()}
            </div>
            <div>
                <Modal backdrop={false} size="lg" isOpen={planModal} style={{ maxWidth: '1200px', width: '100%' }}
                    toggle={togglePlanModal}>
                    <ModalHeader toggle={togglePlanModal}>
                        <span className="display-4">Select your plan</span>
                    </ModalHeader>
                    <ModalBody>
                        <div className="container-fluid">
                            <div className="row px-2">
                                {/* For Stripe */}
                                {/* {plans.map((plan, index) => (
                                    <PlanCard key={index} {...plan} signedInUser={props.signedInUser} />
                                ))} */}

                                {pricingPlans.map((plan, index) => (
                                    <PlanCard key={plan.name} {...plan} signedInUser={props.signedInUser} togglePlanModal={togglePlanModal} />
                                ))}


                            </div>
                        </div>
                    </ModalBody>
                </Modal>
            </div>
        </>

    );
};

export default Assessment;
